import {type Component} from 'vue';
import type {VJoyDialog} from '@maltjoy/core-vue';
import {useCommonOverlayRootLogic, useCommonRenderLogic, type UseOverlayOptions} from './useCommonRenderLogic';

/**
 * To be used by the component/store displaying the dialog
 */
export function useDialog<T extends Component>(DialogComponent: T, options?: UseOverlayOptions<T>) {
    const {closeOverlay, openOverlay} = useCommonRenderLogic(DialogComponent, options);

    return {
        openDialog: openOverlay,
        closeDialog: closeOverlay,
    };
}

/**
 * To be used on *the component containing the Dialog content*
 */
export function useDialogRoot<TConfirm extends (...args: any[]) => void | Promise<void> = () => void | Promise<void>>(open = true) {
    const {PreloadedOverlayComponent, closeOverlay, confirmOverlay, openOverlay, cancelOverlay, loadingCancel, loadingConfirm} =
        useCommonOverlayRootLogic('Dialog', open);

    return {
        TVJoyDialog: PreloadedOverlayComponent as typeof VJoyDialog,
        openDialog: openOverlay,
        closeDialog: closeOverlay,
        confirmDialog: confirmOverlay as (...args: Parameters<TConfirm>) => void,
        cancelDialog: cancelOverlay,
        loadingCancel,
        loadingConfirm,
    };
}
